import * as React from 'react';
import { connect } from 'react-redux';
import { IAppState, Dispatch } from '../../../../common/state';
import { EHouseLineType } from '../../../../json_query';
import { getTermsValue } from '../../../../json_query/reducers/helpers';
import { pushTermsValue, removeTermsValue } from '../../../state/advanced/terms';
import { Row } from '../markup';
import { ButtonCheckboxList } from './button_checkbox_list';

interface IHouseLineBuildingProps {
  selected: EHouseLineType[];
  select(placementType: EHouseLineType): void;
  deselect(placementType: EHouseLineType): void;
}

const houseLineTypes = [
  { title: 'Первая', value: EHouseLineType.First },
  { title: 'Вторая', value: EHouseLineType.Second },
];

class HouseLineBuilding extends React.PureComponent<IHouseLineBuildingProps> {
  public render() {
    const { deselect, selected, select } = this.props;

    return (
      <Row title="Линия домов (здание)">
        <ButtonCheckboxList deselect={deselect} list={houseLineTypes} select={select} selected={selected} />
      </Row>
    );
  }
}

// tslint:disable-next-line:no-default-export
export default connect(
  (state: IAppState) => ({
    selected: getTermsValue('building_house_line_type')(state.filters.jsonQuery),
  }),
  (dispatch: Dispatch) => ({
    select: (value: EHouseLineType) => {
      dispatch(pushTermsValue('building_house_line_type')(value));
    },
    deselect: (value: EHouseLineType) => {
      dispatch(removeTermsValue('building_house_line_type')(value));
    },
  }),
)(HouseLineBuilding);
